/* BiteClutch — nút +/− mượt, tiền nhảy theo số lượng (toàn trang: sản phẩm + giỏ + drawer) */
(function () {
  if (window.__biteCartAjax) return;
  window.__biteCartAjax = true;

  function fmt(c) {
    return '$' + (Math.round(c) / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
  }
  function money(c) { return fmt(c); }

  // ===== CSS chống dark mode cho drawer (luôn nền trắng, chữ tối) =====
  (function injectBiteCss() {
    if (document.getElementById('bite-drawer-css')) return;
    var st = document.createElement('style');
    st.id = 'bite-drawer-css';
    st.textContent =
      'theme-drawer#cart-drawer .theme-drawer__dialog, theme-drawer#cart-drawer dialog,' +
      'theme-drawer#cart-drawer .cart-drawer__content, theme-drawer#cart-drawer .cart-drawer__items, theme-drawer#cart-drawer .cart-drawer__summary,' +
      'theme-drawer#cart-drawer .cart-drawer__inner {' +
      'background:#ffffff !important;color:#0b2545 !important;color-scheme:light !important;' +
      'box-shadow:none !important;border-color:#e5e7eb !important;}' +
      'theme-drawer#cart-drawer .cart-drawer__content *, theme-drawer#cart-drawer .cart-drawer__items *, theme-drawer#cart-drawer .cart-drawer__summary *,' +
      'theme-drawer#cart-drawer .cart-drawer__inner * {' +
      'color-scheme:light !important;}' +
      'theme-drawer#cart-drawer dialog { background:#fff !important; }' +
      /* ===== CỤM MUA HÀNG: bố cục cân đối =====
         Hàng 1: qty selector (trái) + "Tổng cộng" (phải) — cùng hàng, thẳng đáy, cân nhau
         Hàng 2: Add to cart full-width
         Hàng 3: PayPal full-width  */
      '.product-form-buttons--stacked{display:flex;flex-direction:column;gap:10px}' +
      '.product-form-buttons--stacked .quantity-selector-wrapper{display:flex;flex-direction:row;align-items:center;gap:10px;width:100%;margin:0}' +
      '.product-form-buttons--stacked .quantity-selector-wrapper .quantity-selector{flex:0 0 130px}' +
      '.product-form-buttons--stacked #bite-qty-total{flex:1;margin:0 !important;padding:12px 14px;font-size:1.35rem;background:#fff7f5;border:1px solid #ffe0da;border-radius:10px;text-align:center}' +
      '.product-form-buttons--stacked add-to-cart-component{display:block;width:100%}' +
      '.product-form-buttons--stacked add-to-cart-component button{width:100% !important;max-width:100% !important;min-height:52px;font-size:1.05rem;font-weight:800;margin-left:0 !important;margin-right:0 !important}' +
      '.product-form-buttons--stacked .accelerated-checkout-block{width:100%;margin-top:0}' +
      '.product-form-buttons--stacked .accelerated-checkout-block > *{width:100%}' +
      /* Cố định cụm mua hàng khi cuộn — desktop: sticky top; mobile: bar đáy */
      '@media(min-width:768px){.buy-buttons-block{position:sticky;top:14px;z-index:50}}' +
      /* Sticky bar đáy mobile */
      '@media(max-width:767px){' +
      '.bite-sticky-bar{position:fixed;left:0;right:0;bottom:0;z-index:999;background:#fff;border-top:1px solid #e5e7eb;padding:10px 14px calc(10px + env(safe-area-inset-bottom));display:flex;align-items:center;gap:10px;box-shadow:0 -4px 16px rgba(0,0,0,.08);transform:translateY(110%);transition:transform .25s ease}' +
      '.bite-sticky-bar.bite-visible{transform:translateY(0)}' +
      '.bite-sticky-bar .bite-sticky-price{font-weight:800;font-size:1.2rem;color:#0b2545;white-space:nowrap}' +
      '.bite-sticky-bar .bite-sticky-add{flex:1;background:#0b2545;color:#fff;border:none;border-radius:10px;padding:13px;font-weight:800;font-size:.95rem;cursor:pointer}' +
      '.bite-sticky-bar .bite-sticky-add:disabled{background:#9ca3af;cursor:not-allowed}' +
      '.bite-sticky-bar .bite-sticky-checkout{background:#ffc439;color:#003087;border:none;border-radius:10px;padding:13px 16px;font-weight:800;font-size:.9rem;cursor:pointer}' +
      'body.bite-sticky-show{padding-bottom:64px}' +
      '}';
    (document.head || document.documentElement).appendChild(st);
  })();

  /* ============ 1. TRANG SẢN PHẨM: tổng tiền theo số lượng ============ */
  var __unit = {}; // variantId -> price cents

  function productForm() {
    var q = document.querySelector('form input[name="quantity"]');
    return q ? q.closest('form') : null;
  }
  function ensureBox(form) {
    var b = form.querySelector('#bite-qty-total');
    var wrap = form.querySelector('.quantity-selector-wrapper');
    var needStyle = 'flex:1;min-width:0;margin:0;padding:12px 14px;font-weight:800;font-size:1.35rem;color:#ff2d1f;line-height:1.2;background:#fff7f5;border:1px solid #ffe0da;border-radius:10px;text-align:center;box-sizing:border-box;';
    if (b) {
      // Nếu box đang nằm SAI chỗ (trong span Add) — di chuyển vào wrapper
      if (wrap && !wrap.contains(b)) {
        wrap.appendChild(b);
      }
      b.style.cssText = needStyle;
      if (wrap) wrap.style.alignItems = 'center';
      return b;
    }
    b = document.createElement('div');
    b.id = 'bite-qty-total';
    b.style.cssText = needStyle;
    // Đặt vào quantity-selector-wrapper (hàng 1) — cạnh qty selector, cùng hàng
    if (wrap) {
      wrap.appendChild(b);
      wrap.style.alignItems = 'center';
      return b;
    }
    // Fallback: chèn trước nút submit
    var ref = form.querySelector('button[type="submit"], button[name="add"], input[type="submit"]');
    (ref && ref.parentNode ? ref.parentNode : form).insertBefore(b, ref || null);
    return b;
  }
  function currentVariant(form) {
    var idb = form.querySelector('input[name="id"]');
    return idb ? String(idb.value) : null;
  }
  function getUnit(form) {
    var vid = currentVariant(form);
    if (!vid) return Promise.resolve(null);
    if (__unit[vid]) return Promise.resolve(__unit[vid]);
    return fetch(location.pathname.replace(/\/+$/, '') + '.js').then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).find(function (x) { return String(x.id) === vid; });
        __unit[vid] = v ? v.price : ((p.variants && p.variants[0]) ? p.variants[0].price : null);
        return __unit[vid];
      }).catch(function () { return __unit[vid] || null; });
  }
  function updateProductPrice() {
    var form = productForm();
    if (!form) return;
    var qe = form.querySelector('input[name="quantity"]');
    var q = qe ? parseInt(qe.value, 10) : 1;
    if (isNaN(q) || q < 1) q = 1;
    var box = ensureBox(form);
    getUnit(form).then(function (u) {
      if (u == null) { box.textContent = ''; return; }
      var total = u * q;
      box.innerHTML = 'Tổng cộng: <b style="font-size:1.5rem">' + fmt(total) + '</b>' +
        (q > 1 ? ' <span style="font-size:.85rem;font-weight:500;color:#555">(' + q + ' × ' + fmt(u) + ')</span>' : '');
    });
  }

  // Đồng bộ qty + tổng tiền TRANG SẢN PHẨM theo giỏ (sau khi API giỏ thay đổi)
  function syncProductFormFromCart(cart) {
    try {
      var form = productForm();
      if (!form) return;
      var idb = form.querySelector('input[name="id"]');
      var qe = form.querySelector('input[name="quantity"]');
      if (!idb || !qe) return;
      var vid = String(idb.value);
      var item = null;
      for (var i = 0; i < (cart.items || []).length; i++) {
        var x = cart.items[i];
        if (String(x.variant_id) === vid || String(x.id) === vid) { item = x; break; }
      }
      if (item) {
        qe.value = item.quantity;
        var box = ensureBox(form);
        box.innerHTML = 'Tổng cộng: <b style="font-size:1.5rem">' + fmt(item.quantity * (item.price || 0)) + '</b>' +
          (item.quantity > 1 ? ' <span style="font-size:.85rem;font-weight:500;color:#555">(' + item.quantity + ' × ' + fmt(item.price) + ')</span>' : '');
      } else {
        // Sản phẩm không còn trong giỏ → reset về 1 (hoặc min)
        var mn = (qe.min !== '' && qe.min != null) ? (parseInt(qe.min, 10) || 1) : 1;
        qe.value = mn;
        updateProductPrice();
      }
    } catch (e) {}
  }

  /* ============ 2. GIỎ: cập nhật ngầm ============ */
  function applyCart(cart) {
    var items = cart.items || [];
    document.querySelectorAll('#cart-form tr[data-key]').forEach(function (tr) {
      var key = tr.getAttribute('data-key');
      var item = null;
      for (var i = 0; i < items.length; i++) { if (items[i].key === key) { item = items[i]; break; } }
      if (!item) return;
      var input = tr.querySelector('input[name="updates[]"]');
      if (input) input.value = item.quantity;
      var price = tr.querySelector('.cart-items__price text-component') || tr.querySelector('.cart-items__price');
      if (price) price.textContent = fmt(item.final_line_price);
      var minus = tr.querySelector('[name="minus"]');
      var plus = tr.querySelector('[name="plus"]');
      var ruleMin = (item.quantity_rule && item.quantity_rule.min) ? item.quantity_rule.min : 1;
      if (minus) minus.disabled = item.quantity <= ruleMin;
      if (plus) {
        var avail = (typeof item.available_quantity === 'number') ? item.available_quantity : Infinity;
        plus.disabled = item.quantity >= avail;
      }
    });
    var sub = document.querySelector('[data-testid="cart-subtotal-value"]');
    if (sub) sub.textContent = fmt(cart.items_subtotal_price || 0);
    var disc = document.querySelector('.cart-discounts__value');
    if (disc) disc.textContent = cart.total_discount > 0 ? '-' + fmt(cart.total_discount) : '';
    var total = document.querySelector('[data-cart-subtotal]');
    if (total) total.textContent = fmt(cart.total_price || 0);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (window.__biteRenderTiers) { try { window.__biteRenderTiers(); } catch (e) {} }
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' },
      body: 'id=' + encodeURIComponent(key) + '&quantity=' + qty,
      credentials: 'same-origin'
    }).then(function (r) { if (r.status !== 200) throw new Error('change'); return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) { location.reload(); return; }
        applyCart(cart);
      })
      .catch(function () { location.reload(); });
  }

  /* ============ 3.5. ADD TO CART BẰNG AJAX (chặn submit form → trắng màn) ============ */
  function showToast(msg) {
    var old = document.getElementById('bite-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.id = 'bite-toast';
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
      'background:#0b3a5c;color:#fff;padding:14px 22px;border-radius:14px;font-weight:700;font-size:15px;' +
      'box-shadow:0 12px 40px rgba(0,0,0,.35);display:flex;align-items:center;gap:12px;max-width:92vw;' +
      'animation:biteToastIn .25s ease;';
    t.innerHTML = '<span style="font-size:18px">&#10003;</span><span>' + msg + '</span>' +
      '<a href="/cart" style="color:#ffd43b;margin-left:6px;font-weight:800;text-decoration:underline;white-space:nowrap">Xem giỏ</a>';
    document.body.appendChild(t);
    var st = document.createElement('style');
    st.id = 'bite-toast-style';
    st.textContent = '@keyframes biteToastIn{from{opacity:0;transform:translate(-50%,14px)}to{opacity:1;transform:translate(-50%,0)}}';
    if (!document.getElementById('bite-toast-style')) document.head.appendChild(st);
    setTimeout(function () { t.style.transition = 'opacity .4s'; t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 450); }, 3200);
  }
  /* ============ 3.6. DRAWER GIỎ RIÊNG (JS thuần — chống trắng màn 100%) ============ */
  function tierBarHTML(total) {
    var TIERS = [
      { pct: 5,  min: 6500,  name: 'STARTER',   icon: '🎣', best: false },
      { pct: 10, min: 13000, name: 'STOCK UP',  icon: '🎣', best: false },
      { pct: 15, min: 26000, name: 'BEST VALUE',icon: '⭐', best: true },
      { pct: 20, min: 39000, name: 'BIG CATCH', icon: '🔥', best: false }
    ];
    var cur = null, next = null;
    TIERS.forEach(function (t) { if (total >= t.min) cur = t; });
    var idx = TIERS.indexOf(cur);
    if (idx >= 0 && idx < TIERS.length - 1) next = TIERS[idx + 1];
    var pills = TIERS.map(function (t) {
      var on = cur && t.min <= cur.min;
      var isNext = next && t === next;
      // Ô chia rõ: đạt = nền xanh dương sáng + viền; chưa đạt = mờ; mốc kế tiếp = cam nhấn
      var bkg = on ? 'linear-gradient(135deg,rgba(56,189,248,.95),rgba(14,165,233,.85));border:1px solid rgba(125,211,252,.9)' : isNext ? 'linear-gradient(135deg,rgba(255,107,53,.5),rgba(249,115,22,.35));border:1px solid rgba(255,107,53,.7)' : 'rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.18)';
      return '<div style="background:' + bkg + ';border-radius:9px;padding:6px 3px;text-align:center;position:relative">' +
        (on ? '<span style="position:absolute;top:2px;right:4px;font-size:9px;color:#a7f3d0">✓</span>' : '') +
        '<div style="font-size:13px;line-height:1">' + t.icon + '</div>' +
        '<div style="font-size:8px;font-weight:800;letter-spacing:.4px;opacity:.95;margin-top:2px">' + t.name + '</div>' +
        '<div style="font-size:13px;font-weight:800;line-height:1.15">' + t.pct + '%</div>' +
        '<div style="font-size:8px;opacity:.85">' + (t.min / 100) + '+</div>' +
        (t.best ? '<div style="position:absolute;top:-6px;left:50%;transform:translateX(-50%);background:#fbbf24;color:#78350f;font-size:6.5px;font-weight:900;border-radius:99px;padding:1px 5px;white-space:nowrap">★ BEST VALUE</div>' : '') +
        '</div>';
    }).join('');
    var msg, barW, meta;
    if (total >= 39000) {
      msg = '🔥 <b style="color:#ffd166">20% OFF MAX SAVINGS</b> applied at checkout!';
      barW = 100; meta = money(total) + ' / $390+';
    } else if (next) {
      var need = next.min - total;
      var atPct = total >= 26000 ? 15 : total >= 13000 ? 10 : total >= 6500 ? 5 : 0;
      msg = atPct > 0
        ? '🎣 <b style="color:#ffd166">' + atPct + '% OFF</b> applied — add <b style="color:#ffd166">' + money(need) + '</b> more to unlock <b style="color:#ffd166">' + next.pct + '% OFF</b>!'
        : '🎣 Add <b style="color:#ffd166">' + money(need) + '</b> to unlock <b style="color:#ffd166">' + next.pct + '% OFF</b>';
      barW = Math.min(100, Math.round(total / next.min * 100));
      meta = money(total) + ' / $' + (next.min / 100);
    } else {
      var need0 = TIERS[0].min - total;
      msg = '🎣 Add <b style="color:#ffd166">' + money(need0) + '</b> to unlock <b style="color:#ffd166">5% OFF</b>';
      barW = Math.min(100, Math.round(total / TIERS[0].min * 100));
      meta = money(total) + ' / $65';
    }
    return '<div style="background:linear-gradient(135deg,#0b3a5c,#0ea5e9);border-radius:12px;padding:12px;color:#fff;margin:0 0 10px;font-size:12.5px;box-shadow:0 2px 8px rgba(2,42,84,.25)">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;font-weight:800;font-size:13px;margin-bottom:10px"><span>BUY MORE, SAVE MORE 🎣</span><span style="background:#ff6b35;border-radius:99px;padding:2px 10px;font-size:10.5px;font-weight:800">' + (total>=39000?'SAVE 20%':total>=26000?'SAVE 15%':total>=13000?'SAVE 10%':total>=6500?'SAVE 5%':'BUY MORE') + '</span></div>' +
      '<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:6px;margin-bottom:10px">' + pills + '</div>' +
      '<div style="font-weight:700;margin-bottom:6px;font-size:12px">' + msg + '</div>' +
      '<div style="height:8px;background:rgba(255,255,255,.2);border-radius:99px;overflow:hidden;margin-bottom:4px;border:1px solid rgba(255,255,255,.15)"><div style="height:100%;width:' + barW + '%;background:linear-gradient(90deg,#ff6b35,#f59e0b);border-radius:99px;transition:width .5s"></div></div>' +
      '<div style="display:flex;justify-content:space-between;font-size:10.5px;opacity:.95"><span>' + meta + '</span><span style="font-weight:800;color:#ffd166">' + (total>=39000?'20% OFF':next?next.pct+'% OFF':'5% OFF') + '</span></div>' +
      '<div style="font-size:9px;opacity:.7;margin-top:5px;line-height:1.45">Discount applies automatically to this order based on subtotal. Tiers cannot be combined across multiple orders.</div>' +
      '</div>';
  }

  function biteDrawerEl() {
    var d = document.getElementById('bite-drawer');
    if (d) return d;
    var st = document.createElement('style');
    st.id = 'bite-drawer-style';
    st.textContent = '#bite-drawer .tier{background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.22);border-radius:8px;padding:5px 2px;text-align:center}#bite-drawer .tier .t-icon{display:block;font-size:13px}#bite-drawer .tier .t-name{display:block;font-size:8.5px;font-weight:800;opacity:.9;margin-top:1px}#bite-drawer .tier .t-pct{display:block;font-size:13px;font-weight:800}#bite-drawer .tier .t-at{display:block;font-size:8.5px;opacity:.85}#bite-drawer .tier.t-on{background:rgba(16,185,129,.3);border-color:#34d399}#bite-drawer .tier.t-on .t-name{color:#a7f3d0}#bite-drawer .tier.t-next{background:rgba(255,107,53,.3);border-color:#ff6b35}#bite-drawer .tier.t-next .t-name{color:#ffd166}#bite-drawer .tier .t-best{display:block;font-size:7.5px;color:#ffd166;font-weight:800;margin-top:1px}#bite-drawer .tier .tier-check{display:block;font-size:8px;line-height:1}';
    document.head.appendChild(st);
    d = document.createElement('div');
    d.id = 'bite-drawer';
    d.style.cssText = 'position:fixed;top:0;right:0;bottom:0;width:420px;max-width:96vw;background:#fff;z-index:2147483002;box-shadow:-10px 0 40px rgba(0,0,0,.3);transform:translateX(105%);transition:transform .28s ease;display:flex;flex-direction:column;font-family:inherit;';
    d.innerHTML =
      '<div style="display:flex;align-items:center;justify-content:space-between;padding:16px 18px;background:#0b2545;color:#fff;flex-shrink:0">' +
        '<div style="font-weight:800;font-size:16px">Cart <span id="bite-drawer-count">0</span></div>' +
        '<button type="button" id="bite-drawer-close" style="background:none;border:none;color:#fff;font-size:22px;cursor:pointer;line-height:1;padding:4px 10px">✕</button>' +
      '</div>' +
      '<div id="bite-drawer-body" style="flex:1;overflow-y:auto;padding:14px 16px"></div>' +
      '<div id="bite-drawer-foot" style="flex-shrink:0;border-top:1px solid #e5e7eb;padding:12px 16px;background:#fff"></div>';
    document.body.appendChild(d);
    var ov = document.createElement('div');
    ov.id = 'bite-overlay';
    ov.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:2147483001;opacity:0;pointer-events:none;transition:opacity .25s';
    ov.addEventListener('click', closeBiteDrawer);
    document.body.appendChild(ov);
    document.getElementById('bite-drawer-close').addEventListener('click', closeBiteDrawer);
    return d;
  }

  function openBiteDrawer() {
    var d = biteDrawerEl();
    d.style.transform = 'translateX(0)';
    var ov = document.getElementById('bite-overlay');
    if (ov) { ov.style.opacity = '1'; ov.style.pointerEvents = 'auto'; }
    refreshBiteDrawer();
  }
  function closeBiteDrawer() {
    var d = document.getElementById('bite-drawer');
    if (d) d.style.transform = 'translateX(105%)';
    var ov = document.getElementById('bite-overlay');
    if (ov) { ov.style.opacity = '0'; ov.style.pointerEvents = 'none'; }
  }

  function pctLabel(total) { return total>=39000?'20%':total>=26000?'15%':total>=13000?'10%':total>=6500?'5%':'0%'; }

  function refreshBiteDrawer() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var d = document.getElementById('bite-drawer');
        if (!d) return;
        var body = document.getElementById('bite-drawer-body');
        var foot = document.getElementById('bite-drawer-foot');
        var cnt = document.getElementById('bite-drawer-count');
        if (cnt) cnt.textContent = cart.item_count || 0;
        if (!cart.items || cart.items.length === 0) {
          body.innerHTML = '<div style="text-align:center;padding:50px 20px;color:#666"><div style="font-size:40px;margin-bottom:10px">🛒</div><div style="font-weight:700;font-size:16px;margin-bottom:6px">Giỏ hàng đang trống</div><div style="font-size:13px">Thêm sản phẩm để nhận giảm giá 5–20%!</div></div>';
          foot.innerHTML = '';
          return;
        }
        var subtotal = cart.items_subtotal_price || 0;
        body.innerHTML = tierBarHTML(subtotal) + cart.items.map(function (it) {
          var img = (it.image && it.image.url) ? it.image.url : (it.featured_image && it.featured_image.url) ? it.featured_image.url : '';
          var name = it.product_title || it.title || '';
          var varTitle = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
          var unit = it.price || 0;
          var line = it.line_price || (unit * it.quantity);
          var key = it.key || it.id;
          var disc = (it.discounts && it.discounts.length) ? '<div style="color:#e11d48;font-size:12px;margin-top:2px">' + it.discounts.map(function (di) { return di.title; }).join(', ') + '</div>' : '';
          return '<div style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid #f0f0f0">' +
            (img ? '<img src="' + img + '" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:8px;flex-shrink:0">' : '<div style="width:64px;height:64px;background:#f3f4f6;border-radius:8px;flex-shrink:0"></div>') +
            '<div style="flex:1;min-width:0">' +
              '<div style="font-weight:700;font-size:13.5px;line-height:1.25">' + name + '</div>' +
              (varTitle ? '<div style="color:#6b7280;font-size:12px;margin-top:2px">' + varTitle + '</div>' : '') +
              '<div style="margin-top:4px;font-size:12.5px;color:#374151">' + money(unit) + '</div>' +
              disc +
              '<div style="display:flex;align-items:center;gap:8px;margin-top:8px">' +
                '<div style="display:flex;align-items:center;border:1px solid #d1d5db;border-radius:8px;overflow:hidden">' +
                  '<button type="button" data-bite-q="' + key + '" data-bite-d="1" style="border:none;background:#f3f4f6;width:28px;height:28px;font-weight:800;cursor:pointer">−</button>' +
                  '<span style="min-width:32px;text-align:center;font-weight:700;font-size:13px">' + it.quantity + '</span>' +
                  '<button type="button" data-bite-q="' + key + '" data-bite-d="0" style="border:none;background:#f3f4f6;width:28px;height:28px;font-weight:800;cursor:pointer">+</button>' +
                '</div>' +
                '<button type="button" data-bite-del="' + key + '" style="border:none;background:none;color:#9ca3af;font-size:16px;cursor:pointer" title="Xóa">🗑</button>' +
              '</div>' +
            '</div>' +
            '<div style="font-weight:800;font-size:14px;white-space:nowrap">' + money(line) + '</div>' +
          '</div>';
        }).join('');
        foot.innerHTML =
          '<div style="display:flex;justify-content:space-between;font-size:13.5px;margin-bottom:6px"><span>Subtotal</span><b>' + money(subtotal) + '</b></div>' +
          (cart.total_discount > 0 ? '<div style="display:flex;justify-content:space-between;font-size:13.5px;color:#e11d48;margin-bottom:6px"><span>Discount (−' + pctLabel(subtotal) + ')</span><b>−' + money(cart.total_discount) + '</b></div>' : '') +
          '<div style="display:flex;justify-content:space-between;font-size:15px;font-weight:800;border-top:1px solid #e5e7eb;padding-top:8px;margin-bottom:4px"><span>Estimated total</span><span>' + money(cart.total_price || 0) + ' USD</span></div>' +
          '<div style="font-size:11px;color:#6b7280;margin-bottom:10px">Duties and taxes included. Shipping is calculated at checkout.</div>' +
          '<a href="/checkout" style="display:block;text-align:center;background:#0b2545;color:#fff;border-radius:10px;padding:13px;font-weight:800;text-decoration:none;font-size:14.5px">Check out</a>';
        // bind +/− và xóa
        body.querySelectorAll('[data-bite-q]').forEach(function (b) {
          b.addEventListener('click', function () {
            var key = b.getAttribute('data-bite-q');
            var cur = null;
            for (var i = 0; i < cart.items.length; i++) { var x = cart.items[i]; if (String(x.key) === key || String(x.id) === key) { cur = x; break; } }
            var q = cur ? cur.quantity : 1;
            var nq = b.getAttribute('data-bite-d') === '1' ? q - 1 : q + 1;
            if (nq < 1) nq = 0;
            changeQtyKey(key, nq);
          });
        });
        body.querySelectorAll('[data-bite-del]').forEach(function (b) {
          b.addEventListener('click', function () { changeQtyKey(b.getAttribute('data-bite-del'), 0); });
        });
      })
      .catch(function () {});
  }

  function changeQtyKey(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' },
      body: 'id=' + encodeURIComponent(key) + '&quantity=' + qty,
      credentials: 'same-origin'
    }).then(function (r) { if (r.status !== 200) throw new Error('change'); return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (window.__biteRenderTiers) { try { window.__biteRenderTiers(); } catch (e) {} }
        // Đồng bộ qty + tổng tiền TRANG SẢN PHẨM theo giỏ
        syncProductFormFromCart(cart);
        // Refresh drawer theme nếu đang mở
        var td = document.querySelector('theme-drawer#cart-drawer');
        var dd = td ? td.querySelector('dialog') : null;
        if (td && dd && (typeof td.isOpen === 'function' ? td.isOpen() : dd.open)) {
          dd.innerHTML = renderCartDrawerHTML(cart);
          bindDrawerButtons(cart);
        }
        if (cart.items && cart.items.length === 0) {
          var body2 = document.getElementById('bite-drawer-body');
          if (body2) body2.innerHTML = '<div style="text-align:center;padding:50px 20px;color:#666"><div style="font-size:40px;margin-bottom:10px">🛒</div><div style="font-weight:700;font-size:16px">Giỏ hàng đang trống</div></div>';
          var foot2 = document.getElementById('bite-drawer-foot');
          if (foot2) foot2.innerHTML = '';
          var cnt2 = document.getElementById('bite-drawer-count');
          if (cnt2) cnt2.textContent = '0';
        } else {
          refreshBiteDrawer();
        }
      })
      .catch(function () { location.reload(); });
  }

  window.__biteOpenDrawer = openBiteDrawer;
  window.__biteCloseDrawer = closeBiteDrawer;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var qe = f.querySelector('input[name="quantity"]');
    var idb = f.querySelector('input[name="id"]');
    if (!qe || !idb) return; // chỉ bắt form sản phẩm
    e.preventDefault();
    e.stopPropagation();
    var vid = idb.value;
    var qty = parseInt(qe.value, 10) || 1;
    if (!vid) return;
    var btn = f.querySelector('button[type="submit"], button[name="add"]');
    if (btn) {
      btn.disabled = true;
      var old = btn.innerHTML;
      btn.textContent = 'Adding…';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' },
      body: 'id=' + encodeURIComponent(vid) + '&quantity=' + qty,
      credentials: 'same-origin'
    }).then(function (r) { if (r.status !== 200) throw new Error('add'); return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = old; }
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { action: 'add' } })); } catch (e2) {}
        // Cập nhật số lượng giỏ header + tierbar
        fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            if (window.__biteRenderTiers) { try { window.__biteRenderTiers(); } catch (e4) {} }
          })
          .catch(function () {});
        openThemeDrawer();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = old; }
        location.reload();
      });
  });

  /* ============ 3. SỰ KIỆN ============ */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[name="minus"],[name="plus"],.cart-items__remove');
    if (!b) return;

    var tr = b.closest && b.closest('tr[data-key]');
    if (tr) {
      e.preventDefault(); e.stopPropagation();
      var key = tr.getAttribute('data-key');
      if (b.classList && b.classList.contains('cart-items__remove')) { changeQty(key, 0); return; }
      var input = tr.querySelector('input[name="updates[]"]');
      var q = input ? (parseInt(input.value, 10) || 1) : 1;
      changeQty(key, (b.getAttribute('name') === 'plus') ? q + 1 : q - 1);
      return;
    }

    // TRANG SẢN PHẨM: tự tăng/giảm số + cập nhật tiền ngay tại chỗ
    var form = b.closest('form') || document;
    var qe = form.querySelector('input[name="quantity"]');
    if (!qe) qe = document.querySelector('input[name="quantity"]');
    if (!qe) return;
    e.preventDefault(); e.stopPropagation();
    var cur = parseInt(qe.value, 10);
    if (isNaN(cur) || cur < 0) cur = (parseInt(qe.min, 10) || 1);
    var step = parseInt(qe.step, 10) || 1;
    var mn = (qe.min !== '' && qe.min != null) ? (parseInt(qe.min, 10) || 1) : 1;
    var mx = (qe.max !== '' && qe.max != null) ? (parseInt(qe.max, 10) || Infinity) : Infinity;
    var nq = (b.getAttribute('name') === 'plus') ? cur + step : cur - step;
    if (nq < mn) nq = mn;
    if (nq > mx) nq = mx;
    qe.value = nq;
    var scope = b.closest('quantity-selector-component') || form || document;
    var minB = scope.querySelector('[name="minus"]');
    var pluB = scope.querySelector('[name="plus"]');
    if (minB) minB.disabled = nq <= mn;
    if (pluB) pluB.disabled = nq >= mx;
    updateProductPrice();
    // ĐỒNG BỘ GIỎ: nếu sản phẩm đã trong giỏ → gọi /cart/change.js (cùng API với drawer)
    // → drawer + badge + tier + tiền đều cập nhật hệt nhau
    var idb = form.querySelector('input[name="id"]');
    if (idb && idb.value) {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var found = false;
          for (var i = 0; i < (cart.items || []).length; i++) {
            if (String(cart.items[i].variant_id) === String(idb.value) || String(cart.items[i].id) === String(idb.value)) { found = true; break; }
          }
          if (found) {
            changeQtyKey(idb.value, nq); // đấu chung API /cart/change.js
          }
        })
        .catch(function () {});
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && (t.name === 'quantity' || t.name === 'updates[]')) {
      if (t.name === 'quantity') { setTimeout(updateProductPrice, 0); }
    }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.name === 'quantity') { setTimeout(updateProductPrice, 0); return; }
    if (t.name === 'updates[]') {
      var tr = t.closest && t.closest('tr[data-key]');
      if (!tr) return;
      var q = parseInt(t.value, 10);
      if (isNaN(q) || q < 0) q = 1;
      changeQty(tr.getAttribute('data-key'), q);
    }
  });

  // Khởi tạo tổng tiền khi trang sản phẩm sẵn sàng
  setTimeout(updateProductPrice, 600);

  // ĐỌC LẠI DỮ LIỆU: đảm bảo drawer theme nhận đủ dữ liệu khi mở
  // (bỏ killBrokenDrawers — nó CHẶN drawer theme mở, gây trắng màn)

  // GỠ on:click Alpine LỖI (theme dùng Alpine morph nhưng Alpine không nạp được)
  // → nút Add to cart trở thành submit thuần → handler submit của chúng ta bắt → AJAX add
  function stripAlpineClicks() {
    try {
      document.querySelectorAll('form input[name="quantity"]').forEach(function (qe) {
        var f = qe.closest('form');
        if (!f) return;
        f.querySelectorAll('[on\\:click]').forEach(function (el) {
          var v = el.getAttribute('on:click') || '';
          if (v.indexOf('/handleClick') !== -1 || v.indexOf('/increaseQuantity') !== -1 || v.indexOf('/decreaseQuantity') !== -1 || v.indexOf('/onLineItemRemove') !== -1) {
            el.removeAttribute('on:click');
          }
        });
      });
    } catch (e) {}
  }
  stripAlpineClicks();
  setTimeout(stripAlpineClicks, 500); // chạy lại sau khi DOM ổn định

  // HYDRATE GIỎ /cart — CÁCH AN TOÀN: lấy nội dung THẬT của template
  function hydrateCartPage() {
    try {
      var c = document.querySelector('cart-items-component');
      if (!c) return false;
      var tpl = c.querySelector('#empty-cart-template');
      if (!tpl) return false;
      if (c.querySelector('form#cart-form') || c.querySelector('tr[data-key]')) return true;
      var frag = tpl.content.cloneNode(true);
      // Chỉ lấy form#cart-form (nội dung giỏ thật), bỏ phần khác (empty, footer...)
      var form = frag.querySelector ? frag.querySelector('#cart-form') : null;
      if (!form) return false;
      // Đưa form vào component
      c.appendChild(form);
      tpl.remove();
      stripAlpineClicks();
      if (window.__biteRenderTiers) { try { window.__biteRenderTiers(); } catch (e) {} }
      return true;
    } catch (e) { return false; }
  }
  setTimeout(hydrateCartPage, 300);
  setTimeout(hydrateCartPage, 1000);

  /* ============ 5. BẤM NÚT GIỎ HEADER → MỞ DRAWER (không đi /cart trắng) ============ */
  // Giống Rod Locker: giỏ hàng chỉ là drawer, không có trang /cart riêng
  function openThemeDrawer() {
    // 1. Mở drawer theme NGAY (không chờ fetch)
    var td0 = document.querySelector('theme-drawer#cart-drawer');
    if (td0) {
      try { if (typeof td0.open === 'function') td0.open(); } catch (e0) {}
      var dd0 = td0.querySelector('dialog');
      if (dd0 && typeof dd0.showModal === 'function' && !dd0.open) { try { dd0.showModal(); } catch (e0b) {} }
    }
    // 2. Lấy giỏ từ /cart.js (AJAX đáng tin cậy — đã hoạt động trên máy bố)
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var td = document.querySelector('theme-drawer#cart-drawer');
        if (!td) { openBiteDrawer(); return; }
        var dd = td.querySelector('dialog') || td;
        // Render nội dung giỏ hàng bằng JS thuần (không phụ thuộc Section API/theme JS)
        var body = renderCartDrawerHTML(cart);
        dd.innerHTML = body;
        // Bind +/−, xóa sau khi render
        bindDrawerButtons(cart);
        // Nạp upsell "You'll love these"
        loadUpsell(cart);
        // Cập nhật badge
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (window.__biteRenderTiers) { try { window.__biteRenderTiers(); } catch (e2) {} }
        // 3. Mở drawer (lại, phòng khi drawer đóng giữa chừng)
        setTimeout(function () {
          try {
            var td2 = document.querySelector('theme-drawer#cart-drawer');
            if (td2 && typeof td2.open === 'function') td2.open();
            var dd2 = td2 ? td2.querySelector('dialog') : null;
            if (dd2 && typeof dd2.showModal === 'function' && !dd2.open) dd2.showModal();
          } catch (e3) {}
        }, 100);
      })
      .catch(function () {
        // /cart.js fail → thử Section API (fallback 2) → nếu vẫn fail → drawer riêng
        try { openBiteDrawer(); } catch (e) {}
      });
  }
  // Render HTML giỏ hàng (theme drawer style) — dùng chung cho drawer theme
  function tierMinLabel(total) { return total >= 39000 ? '$390+' : total >= 26000 ? '$260+' : total >= 13000 ? '$130+' : '$65+'; }
  function renderCartDrawerHTML(cart) {
    var empty = '<div class="cart-drawer__empty" style="text-align:center;padding:60px 20px;color:#667"><div style="font-size:42px;margin-bottom:12px">🛒</div><div style="font-weight:800;font-size:17px;margin-bottom:6px">Your cart is empty</div><div style="font-size:13.5px">Add bait to unlock 5–20% OFF!</div><a href="/collections/all" style="display:inline-block;margin-top:16px;background:#0b2545;color:#fff;border-radius:10px;padding:12px 28px;font-weight:700;text-decoration:none">Continue shopping</a></div>';
    if (!cart.items || !cart.items.length) return empty;
    var subtotal = cart.items_subtotal_price || 0;
    var pct = pctLabel(subtotal);
    var itemsHTML = cart.items.map(function (it) {
      var img = (it.image && it.image.url) ? it.image.url : (it.featured_image && it.featured_image.url) ? it.featured_image.url : '';
      var name = it.product_title || it.title || '';
      var varTitle = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var unit = it.price || 0;
      var origUnit = (it.original_price && it.original_price > unit) ? it.original_price : 0;
      var line = it.line_price || (unit * it.quantity);
      var origLine = (it.original_line_price && it.original_line_price > line) ? it.original_line_price : 0;
      var key = it.key || it.id;
      var disc = (it.discounts && it.discounts.length) ? '<div style="color:#e11d48;font-size:12px;margin-top:2px">' + it.discounts.map(function (di) { return di.title; }).join(', ') + '</div>' : '';
      return '<div style="display:flex;gap:12px;padding:14px 0;border-bottom:1px solid #f0f0f0;position:relative;color-scheme:light">' +
        '<button type="button" data-bite-del="' + key + '" style="position:absolute;top:8px;right:0;border:none;background:none;color:#c4c4c4;font-size:15px;cursor:pointer" title="Xóa">🗑</button>' +
        (img ? '<img src="' + img + '&width=160" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:8px;flex-shrink:0">' : '<div style="width:64px;height:64px;background:#f3f4f6;border-radius:8px;flex-shrink:0"></div>') +
        '<div style="flex:1;min-width:0;padding-right:22px">' +
          '<div style="font-weight:600;font-size:13px;line-height:1.35;color:#0b2545;padding-right:8px">' + name + '</div>' +
          (varTitle ? '<div style="color:#6b7280;font-size:12px;margin-top:2px">' + varTitle + '</div>' : '') +
          '<div style="margin-top:6px;font-size:13px;color:#374151">' + (origUnit ? '<span style="text-decoration:line-through;color:#9ca3af;margin-right:6px">' + money(origUnit) + '</span>' : '') + '<b style="color:#0b2545">' + money(unit) + '</b></div>' +
          disc +
          '<div style="display:flex;align-items:center;gap:10px;margin-top:10px">' +
            '<div style="display:flex;align-items:center;border:1px solid #d1d5db;border-radius:6px;overflow:hidden;height:30px">' +
              '<button type="button" data-bite-q="' + key + '" data-bite-d="1" style="border:none;background:#f3f4f6;color:#374151;width:28px;height:30px;font-weight:800;cursor:pointer;font-size:15px;line-height:1">−</button>' +
              '<span style="min-width:30px;text-align:center;font-weight:700;font-size:13px;color:#0b2545">' + it.quantity + '</span>' +
              '<button type="button" data-bite-q="' + key + '" data-bite-d="0" style="border:none;background:#f3f4f6;color:#374151;width:28px;height:30px;font-weight:800;cursor:pointer;font-size:15px;line-height:1">+</button>' +
            '</div>' +
            '<span style="font-size:14px;font-weight:800;color:#0b2545;margin-left:auto">' + money(line) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    // Header "Cart • N" căn giữa + X góc phải (chuẩn Rod Locker)
    var header = '<div style="display:flex;align-items:center;justify-content:center;padding:14px 16px;background:#fff;color:#0b2545;border-bottom:1px solid #e5e7eb;position:relative;color-scheme:light">' +
      '<div style="font-weight:800;font-size:16px;color:#0b2545;letter-spacing:.2px">Cart <span style="color:#9ca3af;font-weight:400">•</span> ' + (cart.item_count || 0) + '</div>' +
      '<button type="button" onclick="window.__closeThemeDrawer&&window.__closeThemeDrawer()" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);border:none;background:#f3f4f6;color:#374151;width:30px;height:30px;border-radius:8px;font-size:14px;cursor:pointer;line-height:1">✕</button>' +
      '</div>';
    // Free shipping banner (giống Rod Locker) — $50+ miễn phí
    var shipNeed = 5000;
    var shipLeft = shipNeed - subtotal;
    var shipPct = Math.min(100, Math.round(subtotal / shipNeed * 100));
    var shipMsg = subtotal >= shipNeed ? 'Free shipping unlocked!' : 'Add <b>' + money(shipLeft) + '</b> more for free shipping';
    var shipBar = '<div style="background:#f8fafc;padding:10px 16px;border-bottom:1px solid #e5e7eb;color-scheme:light">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;font-size:12.5px;font-weight:700;color:#0b2545;margin-bottom:7px"><span>' + shipMsg + '</span><span style="font-size:11px;color:#6b7280;font-weight:400">Free Shipping</span></div>' +
      '<div style="display:flex;align-items:center;gap:8px">' +
        '<div style="flex:1;height:8px;background:#e5e7eb;border-radius:99px;overflow:hidden"><div style="height:100%;width:' + shipPct + '%;background:linear-gradient(90deg,#0b2545,#1d4ed8);border-radius:99px;transition:width .5s"></div></div>' +
        '<span style="font-size:16px">🚚</span>' +
      '</div>' +
      '</div>';
    // Upsell "You'll love these" căn giữa trên divider xám (chuẩn Rod Locker)
    var upsellWrap = '<div id="bite-upsell" style="margin-top:16px;color-scheme:light">' +
      '<div style="text-align:center;font-weight:800;font-size:13px;color:#0b2545;letter-spacing:.3px;padding-bottom:10px">You\'ll love these</div>' +
      '<div style="border-bottom:1px solid #e5e7eb;margin-bottom:4px"></div>' +
      '<div id="bite-upsell-list" style="padding:6px 0"><div style="color:#9ca3af;font-size:12px;padding:8px 4px">Loading…</div></div>' +
      '</div>';
    // Footer: Checkout • $XX, PayPal, Or continue shopping (đã bỏ Discount code + Google Pay để drawer ngắn, sản phẩm giỏ hiện nhiều hơn)
    var total = cart.total_price || 0;
    var foot = '<div style="padding-top:14px;color-scheme:light">' +
      '<div style="display:flex;justify-content:space-between;font-size:13.5px;margin-bottom:5px"><span style="color:#374151">Subtotal</span><b style="color:#0b2545">' + money(subtotal) + '</b></div>' +
      (cart.total_discount > 0 ? '<div style="display:flex;justify-content:space-between;font-size:13px;color:#e11d48;margin-bottom:5px"><span>❤️ ' + pct + ' off · ' + tierMinLabel(subtotal) + '</span><b>−' + money(cart.total_discount) + '</b></div>' : '') +
      '<div style="display:flex;justify-content:space-between;font-size:14.5px;font-weight:800;border-top:1px solid #e5e7eb;padding-top:8px;margin-bottom:4px"><span style="color:#0b2545">Estimated total</span><span style="color:#0b2545">' + money(total) + ' USD</span></div>' +
      '<div style="font-size:10.5px;color:#6b7280;margin-bottom:12px">Duties and taxes included. Shipping is calculated at checkout.</div>' +
      '<a href="/checkout" style="display:block;text-align:center;background:#0b2545;color:#fff;border-radius:8px;padding:14px;font-weight:800;text-decoration:none;font-size:14.5px">Checkout • ' + money(total) + '</a>' +
      '<a href="/checkout" style="display:flex;align-items:center;justify-content:center;gap:6px;margin-top:8px;background:#ffc439;color:#003087;border-radius:8px;padding:12px;font-weight:800;text-decoration:none;font-size:13.5px">Pay with <span style="font-style:italic;font-weight:900">Pay<span style="color:#009cde">Pal</span></span></a>' +
      '<div style="text-align:center;margin-top:12px;font-size:12.5px;color:#6b7280"><a href="/collections/all" style="color:#6b7280;text-decoration:underline">Or continue shopping</a></div>' +
      '</div>';
    // Layout cân đối: content = flex column 100% cao; items scroll giữa; summary cố định đáy
    return '<div class="cart-drawer__content" style="display:flex;flex-direction:column;height:100%;max-height:100vh;background:#fff;color:#0b2545;color-scheme:light">' +
      header + shipBar +
      '<div class="cart-drawer__items" style="flex:1;overflow-y:auto;padding:14px 16px 4px;color-scheme:light">' +
        tierBarHTML(subtotal) + itemsHTML + upsellWrap +
      '</div>' +
      '<div class="cart-drawer__summary" style="flex-shrink:0;border-top:1px solid #e5e7eb;padding:12px 16px 16px;background:#fff;color-scheme:light">' +
        foot +
      '</div>' +
      '</div>';
  }
  // Nạp upsell "You'll love these" (recommendations) vào drawer — hiện thẳng (chuẩn Rod Locker)
  function loadUpsell(cart) {
    var list = document.getElementById('bite-upsell-list');
    if (!list || !cart.items || !cart.items.length) return;
    var pid = cart.items[0].product_id;
    fetch('/recommendations/products.js?product_id=' + pid + '&limit=3', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || []).filter(function (p) { return String(p.id) !== String(pid); });
        if (!prods.length) { list.innerHTML = '<div style="color:#9ca3af;font-size:12px;padding:4px">More bait coming soon.</div>'; return; }
        list.innerHTML = prods.slice(0, 3).map(function (p) {
          var v = p.variants && p.variants[0];
          var img = p.featured_image || '';
          var src = '';
          if (img) {
            if (typeof img === 'string') { src = img; }
            else if (img.src) { src = img.src; }
          }
          if (!src && p.images && p.images.length) {
            var i0 = p.images[0];
            src = (typeof i0 === 'string') ? i0 : (i0.src || '');
          }
          var price = v ? (v.price || p.price) : (p.price || 0);
          return '<div style="display:flex;align-items:center;gap:10px;padding:8px 0;border-bottom:1px solid #f3f4f6;color-scheme:light">' +
            (src ? '<img src="' + src + '&width=100" style="width:44px;height:44px;object-fit:cover;border-radius:8px">' : '<div style="width:44px;height:44px;background:#f3f4f6;border-radius:8px"></div>') +
            '<div style="flex:1;min-width:0;font-size:12.5px;font-weight:600;line-height:1.3;color:#0b2545">' + p.title + '</div>' +
            '<button type="button" data-upsell-add="' + v.id + '" style="border:none;background:#0b2545;color:#fff;border-radius:8px;padding:7px 12px;font-weight:700;font-size:12px;cursor:pointer;white-space:nowrap">Add</button>' +
            '</div>';
        }).join('');
        list.querySelectorAll('[data-upsell-add]').forEach(function (b) {
          b.addEventListener('click', function () {
            var id = b.getAttribute('data-upsell-add');
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: id, quantity: 1 }), credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function () { refreshThemeDrawer(); })
              .catch(function () {});
          });
        });
      })
      .catch(function () { list.innerHTML = ''; });
  }
  function bindDrawerButtons(cart) {
    var dd = document.querySelector('theme-drawer#cart-drawer dialog') || document.querySelector('theme-drawer#cart-drawer');
    if (!dd) return;
    dd.querySelectorAll('[data-bite-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-bite-q');
        var cur = null;
        for (var i = 0; i < cart.items.length; i++) { var x = cart.items[i]; if (String(x.key) === key || String(x.id) === key) { cur = x; break; } }
        var q = cur ? cur.quantity : 1;
        var nq = b.getAttribute('data-bite-d') === '1' ? q - 1 : q + 1;
        if (nq < 1) nq = 0;
        changeQtyKey(key, nq);
        refreshThemeDrawer(); // cập nhật lại drawer sau khi đổi
      });
    });
    dd.querySelectorAll('[data-bite-del]').forEach(function (b) {
      b.addEventListener('click', function () {
        changeQtyKey(b.getAttribute('data-bite-del'), 0);
        refreshThemeDrawer();
      });
    });
  }
  function refreshThemeDrawer() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var td = document.querySelector('theme-drawer#cart-drawer');
        if (!td) return;
        var dd = td.querySelector('dialog') || td;
        dd.innerHTML = renderCartDrawerHTML(cart);
        bindDrawerButtons(cart);
        loadUpsell(cart);
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (window.__biteRenderTiers) { try { window.__biteRenderTiers(); } catch (e2) {} }
      })
      .catch(function () {});
  }
  window.__refreshThemeDrawer = refreshThemeDrawer;
  window.__openThemeDrawer = openThemeDrawer;
  function closeThemeDrawer() {
    try {
      var td = document.querySelector('theme-drawer#cart-drawer');
      if (td && typeof td.close === 'function') td.close();
      var dd = td ? td.querySelector('dialog') : null;
      if (dd && dd.open && typeof dd.close === 'function') dd.close();
    } catch (e) {}
  }
  window.__closeThemeDrawer = closeThemeDrawer;
  function bindCartHeader() {
    try {
      document.querySelectorAll('a[href="/cart"], a[href*="/cart"], [data-cart-link], button[data-cart-open]').forEach(function (el) {
        if (el.getAttribute('data-bite-cart-bound')) return;
        el.setAttribute('data-bite-cart-bound', '1');
        el.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          // Mở drawer THEME (đầy đủ nội dung) — không đi /cart
          try { openThemeDrawer(); } catch (e2) {}
        });
      });
    } catch (e) {}
  }
  bindCartHeader();
  setTimeout(bindCartHeader, 800);

  // Lắng nghe đổi biến thể (màu/kích thước) → lấy lại đơn giá
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name && t.name.indexOf('option') === 0) { __unit = {}; setTimeout(updateProductPrice, 250); }
  });

  /* ============ 4. CHẶN MỌI NÚT "ADD TO CART" Ở LỚP CLICK — triệt để, không trắng màn ============ */
  // Bắt cả nút không nằm trong form (quick-add bar, upsell) → add bằng AJAX, chặn điều hướng
  function isAddBtn(el) {
    if (!el) return false;
    var txt = (el.getAttribute && (el.getAttribute('aria-label') || el.title || '')) || '';
    var cls = (el.className && String(el.className)) || '';
    var id = (el.id || '');
    var txt2 = (el.textContent || '').trim().toLowerCase();
    var inForm = !!el.closest('form');
    var isSubmit = el.getAttribute && (el.getAttribute('type') === 'submit' || el.getAttribute('name') === 'add');
    // Chỉ bắt nút thực sự add-to-cart (không bắt nút giỏ/checkout khác)
    var looksAdd = (id.indexOf('AddToCart') !== -1 || id.indexOf('add-to-cart') !== -1 ||
      cls.indexOf('add-to-cart') !== -1 || cls.indexOf('add_to_cart') !== -1 ||
      txt.indexOf('add to cart') !== -1 || txt.indexOf('add') !== -1 ||
      txt2.indexOf('add to cart') !== -1);
    if (isSubmit && looksAdd) return true;
    // Nút trong form sản phẩm (có input quantity) — submit
    if (isSubmit && inForm && el.closest('form').querySelector('input[name="quantity"]')) return true;
    // Quick-add: nút "Add" gần sản phẩm (không có form quantity)
    if ((cls.indexOf('quick-add') !== -1 || cls.indexOf('quickadd') !== -1) && (txt2.indexOf('add') !== -1)) return true;
    return false;
  }
  function addFromButton(btn) {
    var form = btn.closest('form');
    var vid = null, qty = 1;
    if (form && form.querySelector('input[name="id"]')) {
      vid = form.querySelector('input[name="id"]').value;
      var qe = form.querySelector('input[name="quantity"]');
      if (qe) qty = parseInt(qe.value, 10) || 1;
    } else if (btn.getAttribute('data-variant-id') || btn.getAttribute('data-id')) {
      vid = btn.getAttribute('data-variant-id') || btn.getAttribute('data-id');
    } else if (form && form.querySelector('input[name="id"], select[name="id"]')) {
      var idEl = form.querySelector('input[name="id"], select[name="id"]');
      vid = idEl.value;
    }
    if (!vid) {
      // Thử lấy từ URL/JSON — fallback: variant đầu tiên của sản phẩm hiện tại
      var prod = document.querySelector('[data-product-id], [data-id]');
      if (prod && prod.getAttribute('data-variant-id')) vid = prod.getAttribute('data-variant-id');
    }
    if (!vid) return false;
    var old = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' },
      body: 'id=' + encodeURIComponent(vid) + '&quantity=' + qty,
      credentials: 'same-origin'
    }).then(function (r) { if (r.status !== 200) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.disabled = false; btn.innerHTML = old;
        fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            if (window.__biteRenderTiers) { try { window.__biteRenderTiers(); } catch (e4) {} }
          }).catch(function () {});
        openThemeDrawer();
      })
      .catch(function () { btn.disabled = false; btn.innerHTML = old; });
    return true;
  }
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target.closest && e.target.closest('button, [role="button"], a');
      if (!btn) return;
      if (!isAddBtn(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      if (addFromButton(btn)) return;
      // Không lấy được variant → reload an toàn (không trắng màn)
      if (btn.closest('form')) btn.closest('form').submit();
    } catch (e2) {}
  }, true);

  /* ============ STICKY BAR ĐÁY (mobile): luôn có nút mua khi cuộn ============ */
  function initStickyBar() {
    if (document.getElementById('bite-sticky-bar') || window.__biteStickyBar) return;
    // Chỉ trên trang sản phẩm
    var form = document.querySelector('form[data-type="add-to-cart-form"], .product-form-buttons');
    if (!form) return;
    window.__biteStickyBar = true;
    var bar = document.createElement('div');
    bar.id = 'bite-sticky-bar';
    bar.className = 'bite-sticky-bar';
    bar.innerHTML =
      '<span class="bite-sticky-price" id="bite-sticky-price"></span>' +
      '<button type="button" class="bite-sticky-add" id="bite-sticky-add">Add to cart</button>' +
      '<button type="button" class="bite-sticky-checkout" id="bite-sticky-checkout">PayPal</button>';
    document.body.appendChild(bar);
    var priceEl = bar.querySelector('#bite-sticky-price');
    var addBtn = bar.querySelector('#bite-sticky-add');
    var chkBtn = bar.querySelector('#bite-sticky-checkout');
    // Đồng bộ giá từ #bite-qty-total
    function syncPrice() {
      var t = document.getElementById('bite-qty-total');
      if (t) {
        var m = t.textContent.match(/\$[\d.,]+/);
        priceEl.textContent = m ? m[0] : '';
      }
      var mainAdd = form.querySelector('button[name="add"], button[type="submit"]');
      if (mainAdd) addBtn.disabled = mainAdd.disabled || false;
    }
    setInterval(syncPrice, 400);
    syncPrice();
    addBtn.addEventListener('click', function () {
      var mainAdd = form.querySelector('button[name="add"], button[type="submit"]');
      if (mainAdd) { mainAdd.click(); return; }
      form.submit();
    });
    chkBtn.addEventListener('click', function () {
      var mainAdd = form.querySelector('button[name="add"], button[type="submit"]');
      if (mainAdd) mainAdd.click();
      setTimeout(function () { window.location.href = '/checkout'; }, 500);
    });
    // Hiện khi cuộn qua khu vực nút mua — dùng IntersectionObserver (không phụ thuộc scroll container)
    function onScroll() {
      var r = form.getBoundingClientRect();
      var visible = r.bottom < window.innerHeight - 40;
      if (visible) { bar.classList.remove('bite-visible'); document.body.classList.remove('bite-sticky-show'); }
      else { bar.classList.add('bite-visible'); document.body.classList.add('bite-sticky-show'); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    var pw = document.querySelector('.page-wrapper');
    if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
    if ('IntersectionObserver' in window) {
      try {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { onScroll(); });
        }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });
        io.observe(form);
      } catch (e) {}
    }
    setInterval(onScroll, 600);
    onScroll();
    // Nút "Or continue shopping" ẩn khi bar hiện (tránh chồng)
    var cont = document.querySelector('.bite-sticky-bar ~ .cart-drawer__summary a[href="/collections/all"]');
    if (cont) cont.style.display = 'none';
  }
  /* ============ LOW STOCK: random 30–50 (client-side, override mọi số cũ) ============ */
  function lowStockSeed(str) {
    var seed = 0;
    var t = String(str || '');
    for (var i = 0; i < t.length; i++) seed = (seed * 31 + t.charCodeAt(i)) % 100000;
    seed = (seed * 7 + (location.pathname.length || 1) * 13) % 100000;
    return 30 + (seed % 21); // 30–50
  }
  function lowStockFixAll() {
    var path = location.pathname;
    var isProduct = /\/products\//.test(path);
    // 1) Badge low stock (buy-buttons + bất kỳ data-low-stock-badge nào)
    document.querySelectorAll('[data-low-stock-badge]').forEach(function (badge) {
      var countEl = badge.querySelector('[data-low-stock-count]');
      if (!countEl) return;
      var n = lowStockSeed((countEl.textContent || '').trim() + path);
      if (parseInt(countEl.textContent, 10) < 30 || parseInt(countEl.textContent, 10) > 50) {
        countEl.textContent = n;
        badge.setAttribute('data-count', n);
      }
    });
    // 2) product-inventory component — số kho hiển thị "X left"
    if (isProduct) {
      document.querySelectorAll('product-inventory .product-inventory__text').forEach(function (el) {
        var txt = (el.textContent || '').trim();
        var m = txt.match(/(\d+)\s*(left|in stock|remaining|available)/i);
        if (m && (parseInt(m[1], 10) < 30 || parseInt(m[1], 10) > 50)) {
          var n = lowStockSeed(txt + path);
          el.textContent = txt.replace(/(\d+)\s*(left|in stock|remaining|available)/i, n + ' left');
        }
      });
      // 3) Bất kỳ text "X left" nào <30 (dự phòng)
      document.querySelectorAll('body *').forEach(function (el) {
        if (el.children.length !== 0) return;
        var t = (el.textContent || '').trim();
        var m = t.match(/^(\d+)\s+(left|in stock|remaining|available)$/i);
        if (m && (parseInt(m[1], 10) < 30 || parseInt(m[1], 10) > 50)) {
          var n = lowStockSeed(t + path);
          el.textContent = n + ' left';
        }
      });
    }
  }
  function initLowStock() {
    try { lowStockFixAll(); } catch (e) {}
    // MutationObserver: bắt mọi DOM thay đổi (theme render muộn)
    try {
      if (window.__biteLowStockObs) return;
      var obs = new MutationObserver(function () { lowStockFixAll(); });
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
      window.__biteLowStockObs = true;
    } catch (e) {}
  }
  setTimeout(initLowStock, 200);
  setTimeout(initLowStock, 800);
  setTimeout(initLowStock, 1800);
  setTimeout(initLowStock, 3500);

})();
